import { render, staticRenderFns } from "./PurchaseActivityCard.vue?vue&type=template&id=774c5b6e&"
import script from "./PurchaseActivityCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseActivityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774c5b6e')) {
      api.createRecord('774c5b6e', component.options)
    } else {
      api.reload('774c5b6e', component.options)
    }
    module.hot.accept("./PurchaseActivityCard.vue?vue&type=template&id=774c5b6e&", function () {
      api.rerender('774c5b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/PurchaseActivityCard.vue"
export default component.exports